"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ValidationErrors_1 = require("../../../../enums/Validation/ValidationErrors");
const IsUniqueLang_1 = require("../../../decorators/IsUniqueLang");
const Custom_1 = __importDefault(require("../../../decorators/Custom"));
const I18nTextResource_1 = require("../../../I18nText/I18nTextResource");
const Resource_1 = __importDefault(require("../../../Resource"));
class UpcomingActionRequestResource extends Resource_1.default {
}
exports.default = UpcomingActionRequestResource;
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, IsUniqueLang_1.IsUniqueLang)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], UpcomingActionRequestResource.prototype, "title", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, IsUniqueLang_1.IsUniqueLang)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((_description, args) => {
        return args.object.description.every((desc) => desc.text.length < 600);
    }, {
        message: ValidationErrors_1.EValidationError.maxLength,
        context: [600],
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], UpcomingActionRequestResource.prototype, "description", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => I18nTextResource_1.I18nTextResource),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, IsUniqueLang_1.IsUniqueLang)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsOptional)(),
    (0, Custom_1.default)((_buttonLabel, args) => args.object.buttonLink !== undefined, {
        message: ValidationErrors_1.EValidationError.buttonLinkIsRequired,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], UpcomingActionRequestResource.prototype, "buttonLabel", void 0);
__decorate([
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsOptional)(),
    (0, Custom_1.default)((_buttonLink, args) => args.object.buttonLabel !== undefined, {
        message: ValidationErrors_1.EValidationError.buttonLabelIsRequired,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UpcomingActionRequestResource.prototype, "buttonLink", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, Custom_1.default)((startsAt, args) => !!args.object.endsAt && new Date(startsAt) <= args.object.endsAt, {
        message: ValidationErrors_1.EValidationError.wrongDateInterval,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpcomingActionRequestResource.prototype, "startsAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, Custom_1.default)((endsAt, args) => !!args.object.startsAt && args.object.startsAt <= new Date(endsAt), {
        message: ValidationErrors_1.EValidationError.wrongDateInterval,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], UpcomingActionRequestResource.prototype, "endsAt", void 0);
